import styled from "styled-components";
import { Modal } from "react-bootstrap";

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  margin-top: 215px;
  width: 100%;
  max-width: 370px;

  @media (max-width: 768px) {
    margin-top: 0;
    place-self: center;
    min-height: calc(100vh - 356px);
    height: 100%;
  }
`;

export const FormContainer = styled.form`
  margin-top: 45px;
  width: 100%;

  @media (max-width: 768px) {
    margin-top: 0;
  }
`;

export const ContainerButtons = styled.div`
  max-width: 370px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
  display: grid;
  row-gap: 10px;
  margin-bottom: 20px;
  a {
    text-decoration: none;
    width: 100%;
  }
`;

export const ModalContainer = styled.div`
  padding: 25px;
  width: 100%;
`;

export const ModalHeader = styled.header`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 36px;

  span {
    color: ${({ theme }) => theme.colors.blue};
    font-size: 1.125rem;
    font-weight: 600;
  }

  svg {
    color: ${({ theme }) => theme.colors.blue};
    cursor: pointer;
  }
`;

export const ModalBody = styled.div`
  font-size: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  svg {
    margin-right: 16px;
    height: 24px;
    width: 24px;
  }
`;

export const TextBody = styled.p`
  margin-bottom: 0;
  color: #000000;
  margin-top: 25px;
  text-align: center;
`;

export const ModalFooter = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 23px;
  font-size: 1rem;
`;

export const TextFooter = styled.span`
  color: #000000;
  text-align: center;
`;

export const ModalStyle = styled(Modal)`
  .modal-dialog {
    max-width: 450px;
    width: 100%;
  }

  .modal-content {
    max-width: 450px;
    width: 100%;
    border-radius: 10px;
  }

  .modal-dialog-centered {
    place-content: center;
    padding: 0.5rem;
  }
`;

export const HeaderContainer = styled.header`
  display: flex;
  flex-direction: column;

  span {
    font-size: 0.75rem;
    color: #5e5e5e;
    margin-bottom: 22px;
    color: ${({ theme }) => theme.colors.gray};
    display: flex;
    align-items: center;
  }

  h1 {
    font-size: 1.4375rem;
    margin-bottom: 12px;
    color: ${({ theme }) => theme.colors.blue};
  }

  h2 {
    font-size: 0.9375rem;
    margin-bottom: 18px;
    color: ${({ theme }) => theme.colors.gray};
    line-height: 30px;
    font-weight: 400px;
  }

  p {
    color: ${({ theme }) => theme.colors.black};
    font-weight: bold;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;
